import { useEffect, useMemo } from 'react';
import { useGetChainInformationQuery } from '@/entities';
import {
  changeSettings,
  setBrendLogo,
  setCatalogBanners,
  setDemoModeInfo,
  useAppDispatch,
  useAppSelector,
} from '@/app/store';

export const useActualiseSettings = () => {
  const dispatch = useAppDispatch();
  const { data: chainInfo, refetch: chainInfoRefetch, isFetching: isChainInfoFetching } = useGetChainInformationQuery();
  const demoMode = useAppSelector((state) => state.application.demoMode);

  const info = useMemo(() => chainInfo?.data, [chainInfo?.data]);
  const settings = useMemo(() => chainInfo?.data?.settings, [chainInfo?.data?.settings]);

  useEffect(() => {
    chainInfoRefetch();
  }, [chainInfoRefetch]);

  useEffect(() => {
    if (settings) dispatch(changeSettings(settings));
  }, [dispatch, settings]);

  useEffect(() => {
    if (info) {
      const {
        acceptedOwnerDocuments,
        hasActiveSubscription,
        hasLegalInfo,
        brandLogo,
        bannerPhotoDesktop,
        bannerPhotoAdaptive,
      } = info;
      dispatch(setBrendLogo(brandLogo ?? undefined));
      dispatch(setDemoModeInfo({ hasLegalInfo, acceptedOwnerDocuments, hasActiveSubscription }));
      dispatch(
        setCatalogBanners({
          bannerPhotoDesktop: bannerPhotoDesktop ?? undefined,
          bannerPhotoAdaptive: bannerPhotoAdaptive ?? undefined,
        }),
      );
    }
  }, [dispatch, info]);

  useEffect(() => {
    const showDemoModeNote =
      !demoMode.acceptedOwnerDocuments || !demoMode.hasLegalInfo || !demoMode.hasActiveSubscription;
    document.body.classList.toggle('with-demo-note', showDemoModeNote);
    return () => document.body.classList.remove('with-demo-note');
  }, [demoMode.acceptedOwnerDocuments, demoMode.hasLegalInfo, demoMode.hasActiveSubscription]);

  return { chainInfoRefetch, isChainInfoFetching };
};
